import { useQuery } from '@tanstack/react-query';
import { APITypes } from '../../primary-record-types';
import { appAPI } from '../../utils/api';
import { getIntl } from '../../utils/intl';
import urls from '../../utils/urls';
import { getProfileLabDateBucketsCacheKey } from './cacheKeys';
import { useQueryErrorNotify } from '../useQueryCallbacks';

const intl = getIntl('use-lab-date-buckets', {
    loadError: 'Error occurred loading labs',
});

export type UseLabDateBucketsArgs = {
    medicalProfileId: string;
};

export type UseLabDateBucketsReturnValue = {
    isLoadingLabDateBuckets: boolean;
    labDateBuckets: APITypes.medicalDataService.LabDateBucket[];
};

export const useLabDateBuckets = ({ medicalProfileId }: UseLabDateBucketsArgs): UseLabDateBucketsReturnValue => {
    const labDateBucketsQuery = useQuery<APITypes.medicalDataService.LabDateBucket[]>({
        queryKey: getProfileLabDateBucketsCacheKey(medicalProfileId),
        queryFn: async (): Promise<APITypes.medicalDataService.LabDateBucket[]> => {
            const response = await appAPI.get<APITypes.medicalDataService.GetLabDateBucketResponse>(
                urls.api.medicalData.labDateBuckets(medicalProfileId),
            );
            return response.labDateBuckets;
        },
    });

    useQueryErrorNotify(labDateBucketsQuery, intl('loadError'));

    return {
        isLoadingLabDateBuckets: labDateBucketsQuery.isLoading,
        labDateBuckets: labDateBucketsQuery.data || [],
    };
};
